export const loadGoogleMapsScript = () => {
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`
  script.async = true
  script.defer = true
  document.head.appendChild(script)
  return new Promise((resolve) => {
    script.onload = () => resolve(true)
  })
}
